import { isGifUrl, linkInviteToken, splitUrlPunctuation } from './message-presentation';

export interface LinkPreview { url: string; site: string; title: string; description: string; image: string | null }
/** Ignore code and restrict work to two distinct links per message. */
export function messagePreviewUrls(body: string): string[] {
  const text = body.replace(/```[^]*?```|`[^`\n]*`/g, '');
  const found = new Set<string>();
  for (const match of text.matchAll(/https:\/\/[^\s<>]+/g)) {
    try {
      const url = new URL(splitUrlPunctuation(match[0])[0]);
      if (url.username || url.password || url.port || url.href.length > 2048 || isGifUrl(url.href) || linkInviteToken(url.href)) continue;
      found.add(url.href);
      if (found.size >= 2) break;
    } catch { /* Not a website URL. */ }
  }
  return [...found];
}

/** Known public Link pages need no URL disclosure or remote metadata request. */
export function bundledLinkPreview(input: string): LinkPreview | null {
  try {
    const url = new URL(input);
    if (url.protocol !== 'https:' || !['trylink.org', 'www.trylink.org'].includes(url.hostname) || url.port || url.username || url.password) return null;
    const path = url.pathname.replace(/\/$/, '') || '/';
    if (path !== '/' && path !== '/download') return null;
    return {
      url: url.href, site: 'trylink.org',
      title: path === '/download' ? 'Download Link — Windows & web' : 'Link — Messages, calls & communities',
      description: path === '/download'
        ? 'Get Link for Windows, or use it in your browser. Private chats, communities, calls, and screen sharing, with no email or phone number required.'
        : 'Direct messages, group chats, community servers, and calls in one app. Encrypted private chats, with no email or password required.',
      image: '/images/link-liquid-desktop.png',
    };
  } catch { return null; }
}
